import { classNames } from "primereact/utils"
import InputFrame from "./InputFrame"
import TriStateButtons from "./custom/TriStateButtons"

export default function InputTriStateButtonsForm(props) {

    const field = props.controller.field
    const fieldState = props.controller.fieldState

    const onChange = (selected) => {
        field.onChange(selected)
    }

    return (
        <>
            <InputFrame {...props} className="flex">
                <div className="flex flex-row gap-2 align-items-center text-sm">
                    <TriStateButtons
                        id={field.name}
                        inputId={field.name}
                        value={field.value}
                        onChange={onChange}
                        onBlur={field.onBlur}
                        name={field.name}
                        autoComplete="off"
                        className={(fieldState.isDirty ? '' : '') + classNames({ 'p-invalid': fieldState.error })}
                        inputMode={props.inputMode}
                        pattern={props.pattern}
                        onKeyDown={props.onKeyDown}
                        disabled={props.disabled}
                        placeholder={props.placeholder}
                        scaled={props.scaled}
                    />
                </div>

            </InputFrame>
        </>
    )
}
